import type {CreateExtArgs} from '@wix/document-manager-core'
import type {
    CompRef,
    DependenciesBuilder,
    DependenciesManager,
    FixerVersions,
    RawComponentExportStructure
} from '@wix/document-services-types'
import {DATA_TYPES} from '../../../../../constants/constants'
import {resolveDataItem, updateComponentDataItem} from './dataItems'
import type {DataModelExtensionAPI} from '../../../../dataModel/dataModel'
import {COMPONENT_FEATURES} from '../../constants'
import type {ComponentDefinitionExtensionAPI} from '../../../../componentDefinition'

export const getFixerVersions = (
    extensionContext: CreateExtArgs,
    pagePointer: CompRef,
    dependenciesBuilder: DependenciesBuilder
): FixerVersions | undefined => {
    const {extensionAPI} = extensionContext
    const {dataModel} = extensionAPI as DataModelExtensionAPI
    const fixerVersionsPointer = dataModel.components.getItemPointer(pagePointer, DATA_TYPES.fixerVersions)
    if (!fixerVersionsPointer) {
        return undefined
    }

    return resolveDataItem(extensionContext, fixerVersionsPointer, pagePointer, dependenciesBuilder)
}

export const updateFixerVersions = (
    extensionContext: CreateExtArgs,
    componentToReplace: CompRef,
    component: RawComponentExportStructure,
    fixerVersions: FixerVersions | undefined,
    dependenciesManager: DependenciesManager
) => {
    const {pointers, extensionAPI} = extensionContext
    const {componentDefinition} = extensionAPI as ComponentDefinitionExtensionAPI
    const {componentType} = component.structure

    if (pointers.structure.isPage(componentToReplace) || componentDefinition.isPage(componentType)) {
        updateComponentDataItem(
            extensionContext,
            componentToReplace,
            fixerVersions,
            COMPONENT_FEATURES.fixerVersions,
            dependenciesManager,
            componentType
        )
    }
}
